var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',_vm._g(_vm._b({attrs:{"name":"fade","mode":"out-in","enter-active-class":_vm.activeClasses,"leave-active-class":_vm.activeClasses,"enter-class":_vm.enterLeaveClasses,"leave-to-class":_vm.enterLeaveClasses}},'transition',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }